// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VHXQ","index":"styles_index__10rqN"};